// External libraries
import React, { useRef } from 'react';
import { useStoreState } from '@/store';
import {
  FloatingLabelSelect,
  // @ts-expect-error untyped-import
} from '@checkout/react-components';
import { verifyAndResetFullNames } from '../../KanaAndKanjiNames/utils';

// Internal modules
import { features, getContent } from '@/lib';
import { useOnMount } from '@/lib/reactHooks';
import { logSelectNationalityFPTI } from './fpti';
import type { MappedTerritories } from '@/store/models/api/types';
import { LoadingElement } from '@/components/Common';

type NationalitySelectBoxProps = {
  blurHandler: (e: React.FocusEvent<HTMLInputElement>) => void;
  // TODO type the changeHandler
  changeHandler: (e: any, newValue: any, oldValue: any, meta: any) => void;
  focusHandler?: (e: React.FocusEvent<HTMLInputElement>) => void;
  selectOptions: MappedTerritories[];
  shouldFocusOnRender?: boolean;
};

const NationalitySelectBox = (
  props: NationalitySelectBoxProps,
): JSX.Element => {
  const nationality = useStoreState(({ form }) => form.nationality);
  const selectRef = useRef<HTMLSelectElement>(null);
  useOnMount(() => {
    if (props.shouldFocusOnRender && selectRef?.current) {
      selectRef.current.focus();
    }
  });
  const theme = features.get('rebrandFormFieldsTheme');

  // If the territories list is not populated yet (from the initial
  // data GraphQL call), show the loading element
  if (!props.selectOptions?.length) {
    return <LoadingElement />;
  }

  return (
    <FloatingLabelSelect
      blurHandler={props.blurHandler}
      // @ts-expect-error instead of typing any props
      changeHandler={(e, newValue, oldValue, meta) => {
        logSelectNationalityFPTI({ country: newValue });
        props.changeHandler?.(e, newValue, oldValue, meta);
        verifyAndResetFullNames();
      }}
      focusHandler={props.focusHandler}
      id="nationality"
      label={getContent('fieldLabels.nationality')}
      name="nationality"
      required={true}
      selectOptions={props.selectOptions}
      selectRef={selectRef}
      theme={theme}
      {...nationality}
    />
  );
};

export { NationalitySelectBox };
